export default __webpack_public_path__ + "static/media/solicitarIcono2.771aebe6.svg";